import { render } from "./OmnesightAIPage.vue?vue&type=template&id=1ca71174&scoped=true&ts=true"
import script from "./OmnesightAIPage.vue?vue&type=script&lang=ts"
export * from "./OmnesightAIPage.vue?vue&type=script&lang=ts"

import "./OmnesightAIPage.vue?vue&type=style&index=0&id=1ca71174&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca71174"]])

export default __exports__